import React from 'react';
import { BreadcrumbsStyles as S } from './Breadcrumbs.styles';
import SvgChevron from '@img/icons/chevron.svg';
const Breadcrumbs = ({ items }) => {
    return (React.createElement(S.Container, { "aria-label": "breadcrumb" },
        React.createElement(S.BreadcrumbList, null, items.map((item, index) => (React.createElement(S.Breadcrumb, { key: `breadcrumb-${item.id}` }, index !== items.length - 1 ? (React.createElement(React.Fragment, null,
            React.createElement(S.BreadcrumbLink, { href: item.url }, item.text),
            " ",
            React.createElement(SvgChevron, null))) : (React.createElement(S.CurrentBreadcrumb, { "aria-current": "location" }, item.text))))))));
};
export default Breadcrumbs;
